<script lang="ts">
    import Vue from "vue";
    import { Component, mixins } from 'vue-facing-decorator';
    import PortfolioScenariosQueries from "@Quest/PortfolioScenarios/Domain/queries-vue-component";
    import PortfolioScenariosCommands from "@Quest/PortfolioScenarios/Domain/commands-vue-component";
    import { SelectorSettingsReadModel } from "@Quest/PortfolioScenarios/Domain/readmodels";
    import { OptimizeSelectionCommandV1 } from "@Quest/PortfolioScenarios/Domain/commands-core";
    import { ICommandBase } from "@Quest/cqrs";
    import { SelectorDialogViewModel } from "@Quest/PortfolioScenarios/Components/SelectorDialog";

    @Component({
        props: {
            viewModel: { type: Object, required: true }
        },
        watch: {
            opened: 'onOpenedChanged'
        }
    })
    export default class SelectorDialog extends mixins(Vue, PortfolioScenariosQueries, PortfolioScenariosCommands)
    {
        get vm(): SelectorDialogViewModel { return this.$props.viewModel as SelectorDialogViewModel; }
        get opened() : boolean { return this.vm?.opened ?? false; }

        get workspaceId() { return this.vm.workspaceId; }
        get portfolioId() { return this.vm.portfolioId; }
        get scenarioId() { return this.vm.scenarioId; }

        rm: SelectorSettingsReadModel | null = null;

        //@Watch('opened')
        onOpenedChanged(val: boolean, oldVal: boolean)
        {
            if (val)
            {
                this.rm = null;                
                this.runSelectorSettingsQueryV1(this.workspaceId, this.portfolioId, this.scenarioId);
            }
            else
            {
                this.rm = null;
            }
        }


        handleOptimizeSelectionCommand()
        {
            const resources = this.rm.Resources.map(a => `${a.Id}:${a.Capacity}`)
            this.invokeOptimizeSelectionCommandV1(this.workspaceId, this.portfolioId, this.scenarioId, resources, this.rm.TotalCost, this.rm.Opex, this.rm.Capex, this.rm.Othex, this.rm.Expenses, this.rm.OpexExpenses, this.rm.ApplyBenefitsConfidenceFactor);
        }

        close()
        {
            this.vm.close();
        }

        onSetModel(model: any, modelName: string) 
        {
            if (modelName == "SelectorSettingsReadModel")
            {
                const rm = model as SelectorSettingsReadModel;
                this.rm = rm;
            }
        }

        onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
        {
            if (OptimizeSelectionCommandV1.matchType(cmd))
            {
                this.close();
            }
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selector</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div v-if="rm">
                            <div class="form-group">
                                <label>Risk adjusted benefits:</label>
                                <select class="form-control" v-model="rm.ApplyBenefitsConfidenceFactor">
                                    <option :value="true">Enabled</option>
                                    <option :value="false">Disabled</option>
                                </select>
                            </div>

                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Resource</th>
                                        <th style="width: 250px;" class="text-center">Limit</th>
                                    </tr>
                                    <tr v-for="r in rm.Resources" :key="r.Id">
                                        <td>
                                            {{r.Name}}<br />
                                            <small class="text-muted">{{r.Unit}}</small>
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="r.Capacity" />
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr>
                                        <th>Budget</th>
                                        <th style="width: 250px;" class="text-center">
                                            Limit <br />
                                            <small class="text-muted">{{rm.CurrencyLabel}}</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Total cost
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.TotalCost" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Capex
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.Capex" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Opex
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.Opex" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Other expenses
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.Othex" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Expenses (All)
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.Expenses" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Expenses (Opex)
                                        </td>
                                        <td>
                                            <input type="number" class="form-control" v-model.number="rm.OpexExpenses" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="handleOptimizeSelectionCommand" type="button" class="btn btn-success">
                            <i class="fa-solid fa-robot fa-bounce mr-1"></i> Optimize now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>